function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h2',[_vm._v("Make a test call")]),_vm._v(" "),_c('p',[_vm._v("Experience call tracking by calling the phone number below. We are able to link your phone call to your browser. Thus, when calling us, we will immediately notify your browser about it, so you'll see it live. Try it!")]),_vm._v(" "),_c('p',[_vm._v("*"),_c('em',[_vm._v("Note, this is just a demo. We won't answer the phone, nor will call you back.")])])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/interactions/call/details","phone":"International phone number","ring":"Thank you for your call."},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }